import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Measurement } from '../../data/engineering-enums';

@Component({
  selector: 'component-text-box',
  templateUrl: './component-text-box.component.html',
  styleUrl: './component-text-box.component.scss',
  standalone: false
})
export class ComponentTextBoxComponent {

  @Input()
  set Value(value: any) {
    this.value = value;
    this.last = value;
  }
  @Output() ValueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() KeyDown: EventEmitter<any> = new EventEmitter<any>();

  value: any = "";
  last: any = "";

  onChange(event: Event) {
    if (this.value !== this.last) {
      this.last = this.value;
      this.ValueChange.emit(this.value);
    }
  }

  handleKeyDown(event: KeyboardEvent): void {
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        this.onChange(event);
        break;
    }
    this.KeyDown.emit(event);
  }

  focus(event: FocusEvent): void {
    if (event.target instanceof HTMLInputElement) {
      event.target.select();
    }
  }

}
